import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/api/client';
import './Login.css'; // re-uses Login card styling

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    if (!email) {
      setError('Email is required.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err) {
      const e = err as { message?: string };
      setError(e.message || 'Failed to submit request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login">
      <div className="login__card">
        <header className="login__header">
          <img className="login__logo" src="/brew-logo.png" alt="Breww.ai" width={108} height={108} />
          <h1>Forgot Password</h1>
          <p>Enter your email and we'll send you a password reset link.</p>
        </header>

        {success ? (
          <div className="login__form">
            <div style={{
              background: 'color-mix(in srgb, var(--color-accent) 10%, transparent)',
              border: '1px solid color-mix(in srgb, var(--color-accent) 30%, transparent)',
              color: 'var(--text)',
              padding: '1rem',
              borderRadius: 'var(--radius-sm, 8px)',
              fontSize: '0.9rem',
              lineHeight: '1.4',
              textAlign: 'center'
            }}>
              If an account exists for <strong>{email}</strong>, we have sent instructions to reset your password. Please check your inbox.
            </div>
            <Link to="/login" className="login__submit" style={{ textDecoration: 'none', textAlign: 'center', display: 'block' }}>
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login__form" noValidate>
            <label className="login__field">
              <span>Email</span>
              <input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </label>
            {error && <div className="login__error">{error}</div>}
            <button type="submit" className="login__submit" disabled={submitting}>
              {submitting ? 'Sending link…' : 'Send reset link'}
            </button>
          </form>
        )}

        {!success && (
          <footer className="login__footer">
            <Link className="login__link login__link--accent" to="/login">Back to Sign In</Link>
          </footer>
        )}
      </div>
    </div>
  );
}
